// Tracks the last block of text copied out of FELIX™ chat.
//
// Felix assessments name customer behaviour and internal reasoning
// ("she pushed back and was argumentative"). When that text lands in a note
// field, the note must default to internal — never customer-visible.

const KEY = "helix:felix-last-copy";

function normalize(s: string): string {
  return s.replace(/\s+/g, " ").trim();
}

/** Called by FELIX™ when a message is copied to the clipboard. */
export function markFelixCopy(text: string) {
  try {
    sessionStorage.setItem(KEY, normalize(text).slice(0, 4000));
  } catch {
    /* private mode — the default just stays as-is */
  }
}

/** True when the pasted text came out of FELIX™ chat. */
export function isFelixText(pasted: string): boolean {
  const candidate = normalize(pasted);
  if (candidate.length < 12) return false;
  let last = "";
  try {
    last = sessionStorage.getItem(KEY) ?? "";
  } catch {
    return false;
  }
  if (!last) return false;
  return last.includes(candidate) || candidate.includes(last.slice(0, 200));
}
